
const viewportCookieName = 'flivre_viewport'
const viewportReloadedFlag = 'flivreViewportReloaded'

// Detecta o viewport real (janela do navegador) e grava num cookie pro PHP
// decidir quantos posts mostrar por página (components/list-blog.php,
// search.php). 3 faixas: mobile (<=480px), tablet (<=1280px) e desktop
// (>1280px) — consumidores que só checam "=== 'mobile'" continuam
// funcionando normalmente, tratando tablet como desktop.
// Recarrega a página só quando o valor do cookie está desatualizado.
const syncListBlogViewportCookie = () => {

    const width = window.innerWidth
    const bucket = width <= 480 ? 'mobile' : ( width <= 1280 ? 'tablet' : 'desktop' )

    const match = document.cookie.match( new RegExp( '(?:^|; )' + viewportCookieName + '=([^;]*)' ) )
    const current = match ? match[ 1 ] : null

    if( current === bucket ) return

    document.cookie = viewportCookieName + '=' + bucket + '; path=/; max-age=' + ( 60 * 60 * 24 )

    // Evita loop de reload caso o cookie não seja persistido (ex: cookies bloqueados)
    if( sessionStorage.getItem( viewportReloadedFlag ) === bucket ) return
    sessionStorage.setItem( viewportReloadedFlag, bucket )

    window.location.reload()

}

syncListBlogViewportCookie()

// URL base da listagem atual (sem /page/N/ e com "ordem"/"categoria" atualizados).
// A montamos sempre a partir de window.location, nunca do html devolvido pelo
// ajax: o PHP roda dentro do admin-ajax.php nessa hora e não sabe montar a
// URL "bonita" da página real.
const buildListBlogBase = ( section, ordem, categoria ) => {

    const url = new URL( window.location.href )
    url.pathname = url.pathname.replace( /\/page\/\d+\/?$/, '/' ).replace( /\/?$/, '/' )

    if( ordem ) url.searchParams.set( 'ordem', ordem )
    else url.searchParams.delete( 'ordem' )

    // Categoria fixa pela URL (/noticias/{categoria}/) já vem no path, não precisa
    // de querystring; só refletimos na URL a categoria escolhida pelo select
    // (listagem geral, sem categoria no path)
    if( !section.dataset.categ ){
        if( categoria ) url.searchParams.set( 'categoria', categoria )
        else url.searchParams.delete( 'categoria' )
    }

    return url

}

const buildListBlogUrl = ( base, paged ) => {

    const url = new URL( base )
    if( paged > 1 ) url.pathname = url.pathname.replace( /\/$/, '' ) + '/page/' + paged + '/'

    return url

}

// Busca a lista + paginação via ajax e troca o conteúdo da seção, sem reload.
// "categoria" default: preserva a categoria fixa da URL (páginas /noticias/{categ}/)
const fetchListBlog = ( section, paged, ordem, categoria = section.dataset.categ || '' ) => {

    const base = buildListBlogBase( section, ordem, categoria )
    const url = buildListBlogUrl( base, paged )

    const params = new URLSearchParams({
        action: 'flivre_list_blog',
        paged: paged || 1,
        ordem: ordem || '',
        categoria: categoria,
        // Sem is_category()/is_tag() de verdade no ajax, o PHP precisa saber
        // por aqui se "categoria" é slug de categoria ou de tag.
        categoria_tax: section.dataset.categTax || 'category',
        // Diz pro handler ajax (Noticias::ajaxListBlog / Posts::ajaxListBlog,
        // registrados na mesma action) qual dos dois deve responder.
        tipo: section.dataset.type || 'noticias',
        base_url: base.pathname + base.search,
    })

    section.classList.add( 'loading' )

    return fetch( Piki.ajaxurl + '?' + params.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
        .then( response => response.json() )
        .then( data => {

            if( data.status !== 'success' ) return

            section.querySelector( '.posts' ).innerHTML = data.posts
            section.querySelector( '.pagination-wrap' ).innerHTML = data.pagination

            bindListBlogPaginationLinks( section )

            window.history.pushState( {}, '', url )

            section.scrollIntoView({ behavior: 'smooth', block: 'start' })

        })
        .finally( () => {
            section.classList.remove( 'loading' )
        })

}

const initListBlogOrder = ( section ) => {

    const select = section.querySelector( 'select[name="ordem"]' )
    if( !select ) return

    select.addEventListener( 'change', () => {
        const categSelect = section.querySelector( 'select[name="categoria"]' )
        fetchListBlog( section, 1, select.value, categSelect ? categSelect.value : undefined )
    })

}

const initListBlogCateg = ( section ) => {

    const select = section.querySelector( 'select[name="categoria"]' )
    if( !select ) return

    select.addEventListener( 'change', () => {

        // Depois de escolher uma categoria, a opção em branco passa a significar
        // "limpar filtro" em vez de "escolha uma categoria"
        if( select.value ){
            const emptyOption = select.querySelector( 'option[value=""]' )
            if( emptyOption ) emptyOption.textContent = 'Todas as categorias'
        }

        const ordemSelect = section.querySelector( 'select[name="ordem"]' )
        fetchListBlog( section, 1, ordemSelect ? ordemSelect.value : '', select.value )

    })

}

const bindListBlogPaginationLinks = ( section ) => {

    const links = section.querySelectorAll( '.pagination a[data-page]' )
    for( const link of links ){
        link.addEventListener( 'click', ( event ) => {

            event.preventDefault()

            const ordemSelect = section.querySelector( 'select[name="ordem"]' )
            const categSelect = section.querySelector( 'select[name="categoria"]' )

            fetchListBlog(
                section,
                Number( link.dataset.page ),
                ordemSelect ? ordemSelect.value : '',
                categSelect ? categSelect.value : undefined
            )

        })
    }

}

window.addEventListener( 'DOMContentLoaded', () => {

    const section = document.querySelector( 'section.list-blog' )
    if( !section ) return

    initListBlogOrder( section )
    initListBlogCateg( section )
    bindListBlogPaginationLinks( section )

})
